"use strict";
(self["webpackChunktom_bihn"] = self["webpackChunktom_bihn"] || []).push([[662],{

/***/ 4662:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ scrollTrigger)
/* harmony export */ });
/* harmony import */ var jquery__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9755);
/* harmony import */ var jquery__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(jquery__WEBPACK_IMPORTED_MODULE_0__);
// utilities/scroll-trigger.js


/**
 * * Toggles 'on' class on document scroll
 *
 * @options
 * [data-fixed] - y threshold. added to trigger element
 * [data-hide-target] - reference to an element
 * Removes 'on' class when this element comes into view
 */

function scrollTrigger({ wrapper }) {
  const $wrapper = jquery__WEBPACK_IMPORTED_MODULE_0___default()(wrapper)
  console.log('wrapper', $wrapper)

  let settings = {
    yThreshold: $wrapper.data('fixed') || 0,
    $showTarget: $wrapper.data('show-target'),
    $hideTarget: $wrapper.data('hide-target'),
  }

  const handleWindowScroll = () => {
    if (jquery__WEBPACK_IMPORTED_MODULE_0___default()(document.body).hasClass('no-scroll')) {
      return
    }

    const hiddenTargetPosition = jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.$hideTarget).position()
    const showTargetPosition = jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.$showTarget).position()

    const currentScroll = window.pageYOffset 
    const viewPortCenter = currentScroll + window.innerHeight / 2

    if (hiddenTargetPosition && hiddenTargetPosition.top < viewPortCenter) {
      $wrapper.removeClass('tw-on')
    } else if (showTargetPosition && showTargetPosition.top <= viewPortCenter) {
      $wrapper.addClass('tw-on')
    } else if (showTargetPosition && showTargetPosition.top > viewPortCenter) {
      $wrapper.removeClass('tw-on')
    } else {
      $wrapper.toggleClass('tw-on', currentScroll > settings.yThreshold)
    }
  }

  jquery__WEBPACK_IMPORTED_MODULE_0___default()(document).on('scroll', handleWindowScroll)
}


/***/ })

}]);